import { useEffect, useMemo } from 'react';
import { ToastBar, Toast as ToastProps, Toaster, toast } from 'react-hot-toast';
import CloseIcon from '../assets/icons/actions/CloseIcon';
import Theme from './Theme';
import { motion, useAnimation } from 'framer-motion';
import useMobileApp from '../hooks/mobile-app/useMobileApp';
import useTheme from '../hooks/ui/useTheme';

const Toast = ({ t }: { t: ToastProps }) => {
  const animation = useAnimation();
  const theme = useTheme();

  const variants = {
    visible: {
      opacity: 1,
      transition: {
        delay: 0.3,
      },
    },
    hidden: { opacity: 0 },
  };

  useEffect(() => {
    setTimeout(() => onClose(), t.duration === Infinity ? 30000 : t.duration);
  }, []);

  useEffect(() => {
    if (t.visible) {
      animation.start('visible');
    } else {
      animation.start('hidden');
    }
  }, [t.visible, animation]);

  function onClose(): void {
    toast.dismiss(t.id);
  }

  const style = useMemo(() => {
    if (theme.isDarkMode) {
      return {
        backgroundColor: theme.color.black[600],
        color: theme.color.brand.text.primary,
      };
    }
    return {};
  }, [theme]);

  return (
    <motion.div initial="hidden" animate={animation} variants={variants}>
      <ToastBar toast={t} style={style}>
        {({ icon, message }) => (
          <>
            {icon}
            {message}
            {t.type !== 'loading' && (
              <button onClick={() => onClose()}>
                <CloseIcon color={Theme.color.gray['300']} />
              </button>
            )}
          </>
        )}
      </ToastBar>
    </motion.div>
  );
};

const CustomToaster = () => {
  const { insets } = useMobileApp();

  return (
    <Toaster toastOptions={{ duration: 4500 }} containerStyle={{ top: insets.top + 20 }}>
      {(t) => <Toast t={t} />}
    </Toaster>
  );
};

export default CustomToaster;
